import { render, staticRenderFns } from "./DashboardStatistics.vue?vue&type=template&id=0305eaf7&"
import script from "./DashboardStatistics.vue?vue&type=script&lang=js&"
export * from "./DashboardStatistics.vue?vue&type=script&lang=js&"
import style0 from "./DashboardStatistics.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports